import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: theme.spacings.md,
  },
  rowWithPadding: {
    paddingHorizontal: theme.spacings.md,
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.newUI.therapist.primaryBlue10,
  },
  listContainer: {
    justifyContent: 'center',
    width: '100%',
  },
  baseText: {
    fontSize: theme.fontSizes.base,
  },
  semiboldText: {
    fontWeight: '600',
  },
});
